import { createFileRoute, redirect } from '@tanstack/react-router'
import { OpportunityRadarLayout } from '~/features/opportunity-radar/components'

const legacyMatchAlias = /^\/radar\/(?:events|opportunities)\/[^/]+\/?$/
export const Route = createFileRoute('/radar')({
  beforeLoad: ({ location }) => {
    if (legacyMatchAlias.test(location.pathname))
      return
    throw redirect({ href: '/matches', replace: true })
  },
  component: OpportunityRadarLayout,
})
